import { create } from 'zustand';

import { createGeneratorTransferSlice } from './actions';
import type { GeneratorTransferStore } from './types';

export const useGeneratorTransferStore = create<GeneratorTransferStore>()(
  (set, get, store) => ({
    ...createGeneratorTransferSlice(set, get, store),
  }),
);

export type { GeneratorTransferPayload } from './types';
